import axios from 'axios'
import {
  Message,
  MessageBox
} from 'element-ui'
import store from '@/store'
import {
  getToken
} from '@/utils/auth'
const returnCitySN = window.returnCitySN || {}

const instance = axios.create({
  //baseURL: process.env.VUE_APP_BASE_API,
 baseURL: 'http://mcpower.woaideng.com',
   // baseURL: 'http://f73m58.natappfree.cc',
   //baseURL: 'http://localhost:8090',
  // baseURL: 'http://192.168.2.220:8080',
  // withCredentials: true,
  timeout: 500000,
})

instance.interceptors.request.use(
  config => {
    if (store.getters.token) {
      config.headers['token1'] = getToken()
    }
    config.headers['terip'] = returnCitySN['cip'] || ''
    config.headers['platformNo'] = store.getters.platformNo
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

instance.interceptors.response.use(
  response => {
    const {
      code,
      msg
    } = response.data
    if (code === 10) {
      MessageBox.alert(msg, '提示', {
        type: 'error',
        showClose: false
      }).then(async () => {
        await store.dispatch('user/resetToken')
        location.href = '/#/login'
        // location.reload()
      })
      return Promise.reject(new Error(msg || 'Error'))
    }

    if (
      code === -1 || code === -2 || code === -3 || code === -4 || code === -5 ||
      code === 1 || code === 2 || code === 3 || code === 11 || code === 20 || code === 20 ||
      code === 21 || code === 22 || code === 30
    ) {
      Message.error(msg)
      return Promise.reject(new Error(msg || 'Error'))
    }

    return response.data
  },
  error => {
    return Promise.reject(error)
  }
)

export default {
  baseURL: instance.defaults.baseURL,

  get: function (api, params) {
    return new Promise((resolve, reject) => {
      instance.get(api, {
          params
        })
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },

  post: function (api, data) {
    return new Promise((resolve, reject) => {
      instance.post(api, data)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  put: function (api, data) {
     return new Promise((resolve, reject) => {
       instance.put(api, data)
         .then(res => {
           resolve(res)
         })
         .catch(err => {
           reject(err)
         })
     })
   },

  request: instance
}
